import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import WHTransferList from 'components/Inventory/WarehouseTransferWmsList';

const WarehouseTransferWmsList = () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <WHTransferList />
      </SiteContent>
    </ContentLayout>
  );
};

export default WarehouseTransferWmsList;
